import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=456a0684&scoped=true"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationsPanel.vue?vue&type=style&index=0&id=456a0684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a0684",
  null
  
)

export default component.exports